import { render, staticRenderFns } from "./ExamTakerAnswerModal.vue?vue&type=template&id=a9aa824e&scoped=true"
import script from "./ExamTakerAnswerModal.vue?vue&type=script&lang=js"
export * from "./ExamTakerAnswerModal.vue?vue&type=script&lang=js"
import style0 from "./ExamTakerAnswerModal.vue?vue&type=style&index=0&id=a9aa824e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9aa824e",
  null
  
)

export default component.exports